<template>
    <div class="cp-store">
        <marquee :text="'the originals renault store'" />
        <div class="shop dus-container py-lg-80 py-64">
            <div class="title-container">
                <h2 class="title" v-html="$t('home.store.subtitle')"></h2>
                <p class="description">{{ $t("home.store.description") }}</p>
            </div>

            <div class="slot-container mt-32 mb-40">
                <slot />
                <renault-button
                    class="button"
                    :text="$t('home.store.button')"
                    is-black
                    is-anchor
                    :href="storeLink"
                    target="_blank"
                />
                <slot name="museum" />
            </div>

            <div class="vehicles swiper-container store-container">
                <div class="swiper-wrapper">
                    <StoreCard
                        v-for="product in products"
                        :key="product.store_product_id"
                        :product="product"
                    />
                </div>
            </div>

            <div
                class="store-navigation d-flex gap-16 mt-40"
                v-if="showNavigation"
            >
                <div class="button-prev store-button-prev">
                    <svg class="icon-navigation">
                        <use xlink:href="#icon-navigation-prev" />
                    </svg>
                </div>
                <div class="button-next store-button-next">
                    <svg class="icon-navigation">
                        <use xlink:href="#icon-navigation-next" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RenaultButton from "../Shared/RenaultButton.vue";
import Marquee from "../Global/Marquee.vue";
import StoreCard from "./StoreCard.vue";
import Swiper, { Navigation } from "swiper";

Swiper.use([Navigation]);

export default {
    components: {
        RenaultButton,
        Marquee,
        StoreCard,
    },
  
    computed: {
        products() {
            return window.data.store_products;
        },
        currentLang() {
            return this.$store.state.languages.current;
        },
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
        },
        storeLink() {
            return this.currentLang === "fr"
                ? "https://theoriginals-store.renault.com/"
                : `https://theoriginals-store.renault.com/${this.currentLang}`;
        },
        showNavigation() {
            return (this.products.length > 3 && !this.isMobile) || (this.products.length > 1 && this.isMobile);
        },
    },
    mounted() {
        new Swiper(".store-container", {
                slideClass: "card",
                slidesPerView: 1.2,
                slidesPerGroup: 1,
                spaceBetween: 16,
                navigation: {
                    nextEl: ".store-button-next",
                    prevEl: ".store-button-prev",
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                },
            });
    },
};
</script>
